/**
 * The restaurant's wastage cost, from GET /api/wastage rows.
 *
 * A row carrying banquet_event_id is banquet wastage: it is ordinary wastage for
 * stock and expense, but its cost comes off that banquet's gross profit, never
 * the restaurant's — so the Dashboard's "wastage today / this week" leaves it out.
 *
 * Accepts the service payload ({ data: [...] }) or a bare array of rows. A cost
 * that cannot be read adds nothing rather than turning the total into NaN.
 */
export function restaurantWastageTotal(payload) {
  const rows = Array.isArray(payload)
    ? payload
    : (payload && Array.isArray(payload.data) ? payload.data : []);
  return rows.reduce((total, r) => {
    if (!r || r.banquet_event_id) return total;
    const cost = Number(r.estimated_cost_impact || 0);
    return Number.isFinite(cost) ? total + cost : total;
  }, 0);
}

export default restaurantWastageTotal;
